import { render, staticRenderFns } from "./ask.vue?vue&type=template&id=06fde699"
import script from "./ask.vue?vue&type=script&lang=js"
export * from "./ask.vue?vue&type=script&lang=js"
import style0 from "./ask.vue?vue&type=style&index=0&id=06fde699&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports